import React, { Component, PropTypes } from 'react'
import Option from '../../Option'
import styles from './AddRewardModal.css'
import {Button, Modal, ListGroup, ListGroupItem} from 'react-bootstrap'
import PercentageTypeInput from './PercentageTypeInput'
import AmountTypeInput from './AmountTypeInput'

class AddRewardModal extends Component {

  constructor (props) {
    super(props)
    this.state = this._initialState()
  }

  render () {
    return (
      <div>
        <Modal show={this.props.show} backdrop='static'>
          <Modal.Header>
            <Modal.Title style={{color: '#ffffff'}} className='text-center'>Add Reward</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '25px 47px 15px 47px' }}>
            <div style={{fontSize: '18px'}} className={`${styles['title']} bottom20`}>Reward Type</div>
            <ListGroup>
              <ListGroupItem className={`${this.state.discountType === 'PERCENTAGE' ? styles['active'] : ''} ${styles.reward} bottom10 cursor-pointer`}>
                <Option
                  img={require('assets/images/percentage.png')}
                  title='Y Point = X% Discount of Total Sale'
                  body='Customers will get some percentages discount off an entire transaction when they redeem this reward.'
                  isDisabled={false}
                  type='PERCENTAGE'
                  onClick={this._onClickOption}
                />
              </ListGroupItem>
              <ListGroupItem className={`${this.state.discountType === 'AMOUNT' ? styles['active'] : ''} ${styles.reward} bottom10 cursor-pointer`}>
                <Option
                  img={require('assets/images/rp.png')}
                  title='Y Point = Rp X Discount of Total Sale'
                  body='Customers will get some rupiahs discount off an entire transaction when they redeem this reward.'
                  isDisabled={false}
                  type='AMOUNT'
                  onClick={this._onClickOption}
                />
              </ListGroupItem>
              <ListGroupItem className={`${styles['disabled']} bottom20 cursor-not-allowed`}>
                <Option
                  img={require('assets/images/ic-gift.png')}
                  title='Y Point = X% Discount on Item (Coming Soon)'
                  body='Customers will get some percentages discount off any specific item or category when they redeem this reward.'
                  isDisabled
                />
              </ListGroupItem>
            </ListGroup>
            {this.state.discountType === 'PERCENTAGE' && <PercentageTypeInput
              point={this.state.point}
              onChangePoint={this._onChangePoint}
              pointInputError={this.state.pointInputError}
              discount={this.state.discount}
              onChangeDiscount={this._onChangeDiscount}
              discountInputError={this.state.discountInputError}
              isMaximumDiscountEnabled={this.state.isMaximumDiscountEnabled}
              onChangeMaximumDiscountCheckbox={this._onChangeMaximumDiscountCheckbox}
              maximumDiscount={this.state.maximumDiscount}
              onChangeMaximumDiscount={this._onChangeMaximumDiscount}
              maximumDiscountInputError={this.state.maximumDiscountInputError}
            />}
            {this.state.discountType === 'AMOUNT' && <AmountTypeInput
              point={this.state.point}
              onChangePoint={this._onChangePoint}
              pointInputError={this.state.pointInputError}
              discount={this.state.discount}
              onChangeDiscount={this._onChangeDiscount}
              discountInputError={this.state.discountInputError}
              isMinimumPurchaseEnabled={this.state.isMinimumPurchaseEnabled}
              onChangeMinimumPurchaseCheckbox={this._onChangeMinimumPurchaseCheckbox}
              minimumPurchase={this.state.minimumPurchase}
              onChangeMinimumPurchase={this._onChangeMinimumPurchase}
              minimumPurchaseInputError={this.state.minimumPurchaseInputError}
            />}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this._onClickCancel} className='btn btn-default pull-left'>Cancel</Button>
            <Button
              onClick={this._onClickAdd}
              className='btn btn-primary pull-right'
              disabled={this._isAddButtonDisabled()}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _initialState = () => {
    return {
      discountInputError: null,
      pointInputError: null,
      maximumDiscountInputError: null,
      minimumPurchaseInputError: null,
      discountType: 'PERCENTAGE',
      point: '',
      discount: '',
      maximumDiscount: '',
      isMaximumDiscountEnabled: false,
      minimumPurchase: '',
      isMinimumPurchaseEnabled: false
    }
  }

  _isAddButtonDisabled = () => {
    const {
      discountInputError,
      pointInputError,
      maximumDiscountInputError,
      minimumPurchaseInputError,
      isMaximumDiscountEnabled,
      isMinimumPurchaseEnabled
    } = this.state
    if (discountInputError !== '' || pointInputError !== '') {
      return true
    }

    if (isMaximumDiscountEnabled && maximumDiscountInputError !== '') {
      return true
    }

    if (isMinimumPurchaseEnabled && minimumPurchaseInputError !== '') {
      return true
    }

    return false
  }

  _onClickOption = (discountType) => {
    this.setState(this._initialState())
    this.setState({discountType})
  }

  _onClickCancel = (e) => {
    e.stopPropagation()
    this.setState(this._initialState())
    this.props.hideModal()
  }

  _onChangePoint = (displayedPoint, rawPoint) => {
    let pointInputError = ''
    if (rawPoint <= 0) {
      pointInputError = 'Please input a value'
    } else {
      const { rewards } = this.props
      let maximum = 999999999999
      if (rawPoint > maximum) {
        rawPoint = this.state.point
      }

      if ($.isNumeric(rawPoint)) {
        rawPoint = parseInt(rawPoint)
      }

      for (let i = 0; i < rewards.length; i++) {
        if (rewards[i].deleted) {
          continue
        }
        if (rewards[i].point === rawPoint && rewards[i].discountType === this.state.discountType) {
          pointInputError = 'Value cannot be the same with the existing rewards'
        }
      }
    }

    this.setState({ point: rawPoint, pointInputError })
  }

  _onChangeDiscount = (displayedDiscount, rawDiscount) => {
    let discountInputError = ''
    if (rawDiscount <= 0) {
      discountInputError = 'Please input a value'
    } else {
      const { rewards } = this.props
      let maximum = this.state.discountType === 'PERCENTAGE' ? 100 : 999999999999
      if (rawDiscount > maximum) {
        rawDiscount = this.state.discount
      }

      if ($.isNumeric(rawDiscount)) {
        rawDiscount = parseInt(rawDiscount)
      }

      for (let i = 0; i < rewards.length; i++) {
        if (rewards[i].deleted) {
          continue
        }
        if (rewards[i].discount === rawDiscount && rewards[i].discountType === this.state.discountType) {
          discountInputError = 'Value cannot be the same with the existing rewards'
        }
      }
    }
    this.setState({ discount: rawDiscount, discountInputError })
  }

  _onChangeMaximumDiscount = (displayedDiscount, rawDiscount) => {
    let maximumDiscountInputError = ''
    if (rawDiscount < 1000) {
      maximumDiscountInputError = 'Minimum value is Rp 1000'
    } else {
      let maximum = 999999999999
      if (rawDiscount > maximum) {
        rawDiscount = this.state.maximumDiscount
      }

      if ($.isNumeric(rawDiscount)) {
        rawDiscount = parseInt(rawDiscount)
      }
    }

    this.setState({ maximumDiscount: rawDiscount, maximumDiscountInputError })
  }

  _onChangeMinimumPurchase = (displayedPurchase, purchase) => {
    let minimumPurchaseInputError = ''
    if (purchase < 1000) {
      minimumPurchaseInputError = 'Minimum value is Rp 1000'
    } else {
      let maximum = 999999999999
      if (purchase > maximum) {
        purchase = this.state.minimumPurchase
      }

      if ($.isNumeric(purchase)) {
        purchase = parseInt(purchase)
      }
    }

    this.setState({ minimumPurchase: purchase, minimumPurchaseInputError })
  }

  _onClickAdd = (e) => {
    e.stopPropagation()
    const { point, discount, discountType, minimumPurchase, maximumDiscount } = this.state
    this.props.hideModal()
    this.props.addReward({ discountType, point, discount, minimumPurchase, maximumDiscount })
    this.setState(this._initialState())
  }

  _onChangeMaximumDiscountCheckbox = (e) => {
    let nextCheckBoxState = !this.state.isMaximumDiscountEnabled
    if (!nextCheckBoxState) {
      this.setState({
        maximumDiscount: '',
        maximumDiscountInputError: null
      })
    }
    this.setState({isMaximumDiscountEnabled: nextCheckBoxState})
  }

  _onChangeMinimumPurchaseCheckbox = (e) => {
    let nextCheckBoxState = !this.state.isMinimumPurchaseEnabled
    if (!nextCheckBoxState) {
      this.setState({
        minimumPurchase: '',
        minimumPurchaseInputError: null
      })
    }
    this.setState({isMinimumPurchaseEnabled: nextCheckBoxState})
  }
}

AddRewardModal.propTypes = {
  rewards: PropTypes.array.isRequired,
  addReward: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired
}

export default AddRewardModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/Reward/AddRewardModal/AddRewardModal.js